/* Whole house contact pop-up (#cqh-contact in sections/cq-whole-house-v10.liquid), 2026-10-15 (AJ 22:28: "create the
   background HubSpot form, connect it to the Help Desk (Support Pipeline, New, no owner), and fold the site-form swap
   into the cleaner pop-up request"). The site's own form is the only form in the pop-up. On send it posts in the
   background to HubSpot form "Web: Whole House - Free Recommendation", which opens a Help Desk ticket. It follows the
   quiz dialog (assets/cq-well-v3-quiz.js: hsPost, hsSubmit, hsContext): the public form endpoint (no token in the
   theme), an 8 second timeout, the hubspotutk cookie, the page address and title, and the form's legitimate interest
   notice (sent again without it if HubSpot rejects the consent block).
   - HTTP 200: the dialog's thank-you note, the same one a Shopify post shows on ?contact_posted=true (focus and announcement).
   - a bad email (here, or HubSpot's 400 INVALID_EMAIL or BLOCKED_EMAIL): an error on the email field.
   - anything else (network error, timeout, 5xx, any other 4xx, a blocked request): the same form posts to Shopify's
     /contact as before (a help@ email ticket, also in the Support Pipeline), so no request is lost.
   - a filled "Company website" honeypot (bots): the thank-you note, and nothing is sent anywhere.
   With JavaScript off, or without the form's data-cqh-hs-portal and data-cqh-hs-form, it posts to Shopify as before.
   Loaded deferred by the section; it does not touch cq-wh-v10.js (built, minified). */
(() => {
  'use strict';
  const win = window, doc = document;
  const dlg = doc.getElementById('cqh-contact');
  const form = dlg && dlg.querySelector('form[data-contact-native]');
  if (!form || form.dataset.cqhHsWired) return;
  form.dataset.cqhHsWired = '1';

  const S = {
    subject: 'Whole house page: free recommendation request',
    unreachable: ' (HubSpot unreachable)',
    thanks: 'Thank you. Your request is with our team, and a specialist will be in touch.',
    sent: 'Your request was sent.',
    sending: 'Sending',
    emailInvalid: 'That email does not look complete. Check it and try again.',
    sendFailed: 'We could not send this just now. Please try again, or call ',
    phone: '(800) 934-0051', tel: 'tel:18009340051',
    privacy: 'We use these details only to reply about your water.'
  };
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const arr = x => (Array.isArray(x) ? x : []);
  const email = form.querySelector('[name="contact[email]"]');
  const err = form.querySelector('[data-contact-email-err]');
  const status = form.querySelector('[data-contact-status]');
  const btn = form.querySelector('[type="submit"]');
  let pending = false;

  const hs = () => {
    const c = form.dataset;
    return c.cqhHsPortal && c.cqhHsForm ? {portal: c.cqhHsPortal, form: c.cqhHsForm, host: c.cqhHsHost || 'api-na2.hsforms.com'} : null;
  };
  const announce = t => {
    const a = doc.getElementById('cqh-announcer'); if (!a) return;
    a.textContent = ''; win.setTimeout(() => { a.textContent = t; }, 30);
  };

  /* ---------- HubSpot (the quiz pattern) ---------- */
  function pageUri() {
    const loc = win.location, q = new URLSearchParams(loc.search), keep = new URLSearchParams();
    q.forEach((v, k) => { if (/^utm_/.test(k)) keep.append(k, v); });
    const qs = keep.toString();
    return loc.origin + loc.pathname + (qs ? '?' + qs : '');
  }
  function hsContext() {
    const m = /(?:^|;\s*)hubspotutk=([^;]+)/.exec(doc.cookie || '');
    const c = {pageUri: pageUri(), pageName: doc.title || ''};
    if (m) c.hutk = m[1];
    return c;
  }
  async function hsPost(c, body) {
    if (!c) return {ok: false, status: 0, reason: 'off'};
    const url = 'https://' + c.host + '/submissions/v3/integration/submit/' + encodeURIComponent(c.portal) + '/' + encodeURIComponent(c.form);
    const ctrl = typeof win.AbortController === 'function' ? new win.AbortController() : null;
    const timer = win.setTimeout(() => { if (ctrl) ctrl.abort(); }, 8000);
    try {
      const res = await win.fetch(url, {method: 'POST', mode: 'cors', credentials: 'omit', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined});
      let data = null; try { data = await res.json(); } catch (_) {}
      return {ok: res.ok, status: res.status, data, reason: res.ok ? '' : 'http-' + res.status};
    } catch (e) { return {ok: false, status: 0, data: null, reason: e && e.name === 'AbortError' ? 'timeout' : 'network'}; }
    finally { win.clearTimeout(timer); }
  }
  const hsErrors = r => arr(r && r.data && r.data.errors).map(e => String((e && e.errorType) || '') + ' ' + String((e && e.message) || ''));
  async function hsSubmit(c, body) {
    let r = await hsPost(c, body);
    const emailErr = x => !x.ok && x.status === 400 && hsErrors(x).some(t => /INVALID_EMAIL|BLOCKED_EMAIL/i.test(t));
    // if this portal rejects the consent block, the form's own consent settings apply and the theme sends none
    if (!r.ok && r.status === 400 && !emailErr(r) && body.legalConsentOptions && hsErrors(r).some(t => /consent|legal/i.test(t))) {
      const b2 = Object.assign({}, body); delete b2.legalConsentOptions; r = await hsPost(c, b2);
    }
    return Object.assign(r, {emailErr: emailErr(r)});
  }
  const field = (name, value, type) => ({objectTypeId: type || '0-1', name, value: String(value)});
  function hsBody() {
    const v = n => { const el = form.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; };
    const fields = [field('firstname', v('contact[first_name]'))];
    if (v('contact[last_name]')) fields.push(field('lastname', v('contact[last_name]')));
    fields.push(field('email', v('contact[email]')));
    if (v('contact[phone]')) fields.push(field('phone', v('contact[phone]')));
    if (v('contact[zip]')) fields.push(field('zip', v('contact[zip]')));
    fields.push(field('content', v('contact[body]'), '0-5'));
    fields.push(field('subject', S.subject, '0-5'));
    return {fields, context: hsContext(), legalConsentOptions: {legitimateInterest: {value: true, subscriptionTypeId: 935551697, legalBasis: 'LEAD', text: S.privacy}}};
  }

  /* ---------- states ---------- */
  function emailError(msg) {
    if (!email) return;
    if (err) { err.textContent = msg || ''; err.hidden = !msg; }
    if (msg) {
      email.setAttribute('aria-invalid', 'true');
      if (err && err.id) email.setAttribute('aria-describedby', err.id);
      try { email.focus(); } catch (_) {}
    } else {
      email.removeAttribute('aria-invalid'); email.removeAttribute('aria-describedby');
    }
  }
  if (email) email.addEventListener('input', () => { if (email.hasAttribute('aria-invalid')) emailError(''); });
  function busy(on) {
    if (!btn) return;
    if (on) { btn.dataset.cqhLabel = btn.innerHTML; btn.setAttribute('aria-disabled', 'true'); btn.textContent = S.sending; return; }
    btn.removeAttribute('aria-disabled');
    if (btn.dataset.cqhLabel != null) { btn.innerHTML = btn.dataset.cqhLabel; delete btn.dataset.cqhLabel; }
  }
  // the page after a Shopify post: an empty form under the thank-you note
  function showThanks() {
    form.reset(); emailError('');
    if (!status) return;
    status.textContent = S.thanks; status.hidden = false;
    try { status.focus({preventScroll: true}); } catch (_) {}
    announce(S.sent);
  }
  function showFailed() {
    if (!status) return;
    status.textContent = S.sendFailed;
    const a = doc.createElement('a'); a.href = S.tel; a.textContent = S.phone;
    status.appendChild(a); status.appendChild(doc.createTextNode('.'));
    status.hidden = false;
    try { status.focus({preventScroll: true}); } catch (_) {}
  }

  /* ---------- the Shopify fallback (the quiz's shopifyFallback) ----------
     The store's spam check (captcha-bootstrap) cancels a contact form submit until hCaptcha is bound to that form.
     Shopify.captcha.protect binds it first, then the form submits through its own handlers, as if the customer pressed
     Send again. If the page has not moved on 10 seconds later, the note says so and gives the phone number. */
  function shopifyFallback() {
    let left = false, stuck = false, submitted = false;
    const onHide = () => { left = true; };
    win.addEventListener('pagehide', onHide);
    win.setTimeout(() => {
      if (left) return;
      stuck = true;
      win.removeEventListener('pagehide', onHide);
      delete form.dataset.cqhFallback;
      pending = false; busy(false); showFailed();
    }, 10000);
    const send = () => {
      if (stuck || submitted) return;
      submitted = true; form.dataset.cqhFallback = '1';
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    };
    try {
      const cap = win.Shopify && win.Shopify.captcha;
      if (cap && typeof cap.protect === 'function') { cap.protect(form, send); return; }
    } catch (e) { console.warn('[cqh] contact captcha protect failed', e); }
    send();
  }
  // back to a page kept in the back-forward cache after the fallback post: the button is ready again
  win.addEventListener('pageshow', e => { if (e.persisted) { pending = false; busy(false); delete form.dataset.cqhFallback; } });

  async function onSubmit(e) {
    // a flagged submission is the Shopify fallback: let it post
    if (form.dataset.cqhFallback === '1') { delete form.dataset.cqhFallback; return; }
    const c = hs();
    if (!c) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (pending) return;
    const hp = form.querySelector('[data-cqh-hp]');
    if (hp && hp.value) { showThanks(); return; }
    if (!EMAIL_RE.test(String((email && email.value) || '').trim())) { emailError(S.emailInvalid); return; }
    emailError('');
    if (status && !status.hidden) { status.hidden = true; status.textContent = ''; }
    pending = true; busy(true);
    const res = await hsSubmit(c, hsBody());
    if (res.ok) { pending = false; busy(false); showThanks(); return; }
    if (res.emailErr) { pending = false; busy(false); emailError(S.emailInvalid); return; }
    const subj = form.querySelector('[name="contact[subject]"]');
    if (subj && subj.value.indexOf(S.unreachable) < 0) subj.value = subj.value + S.unreachable;
    // the button keeps "Sending" until the page moves on (or the watchdog gives the customer the phone number)
    shopifyFallback();
  }
  // capture on the dialog, so this runs before the store's own submit handlers
  dlg.addEventListener('submit', e => { if (e.target === form) onSubmit(e); }, true);
})();
